import React from "react";
import _ from "lodash";
import EventDetailCard from "./EventDetailCard";
import type {LiveEventAreaModel, LiveEventModel} from "../types/LiveEvent";
import {Circle} from "lucide-react";

interface EventDetailPanelProps {
    selectedNeighborhood?: LiveEventModel[],
    setSetSelectedNeighborhood?: (item: LiveEventAreaModel | null) => void
}

const EventDetailPanel: React.FC<EventDetailPanelProps> = ({selectedNeighborhood, setSetSelectedNeighborhood}) => {
    if (_.isNil(selectedNeighborhood))
        return null;

    const bgColorEventStatus = (eventStatus: string) => {
        switch (eventStatus) {
            case 'Starting Soon':
                return '#00BCD4';
            case'Ending Soon':
                return '#FF9800';
            default:
                return '#00C853';
        }
    }
    return (
        <div
            className="flex justify-start flex-col flex-wrap items-center gap-2 overflow-auto dark:text-gray-300 w-full">
            {_.map((selectedNeighborhood || []), (item, i) => (
                <EventDetailCard
                    eventDetail={({
                        name: item?.event_name || "Unknown Event",
                        status: item?.status || "Unknown",
                        startTime: item?.start_time ? new Date(item.start_time) : null,
                        endTime: item?.end_time ? new Date(item.end_time) : null,
                        categories: item.categories || [],
                        engagementRate: item?.engagement_rate || 0,
                        id: item?.event_id,
                        totalNonCivicUsers: item?.non_civic_points_users || 0,
                        totalAttendees: item?.total_attendees || 0,
                        totalCivicUsers: item?.civic_points_users || 0
                    })}
                    isDetail={(selectedNeighborhood.length === 1)}
                    iconBgColor={bgColorEventStatus(item.status)}
                    icon={Circle}
                    key={i}/>
            ))}
        </div>
    )

}

export default EventDetailPanel;